export default class PaymentNoticeController {
  constructor($state, AuthService) {
    this.state = $state;
    this.auth = AuthService;
  }

  logout(){
    this.auth.logout().subscribe(data => {
      this.state.go('login');
    }, () => {
      this.state.go('login');
    })
  }

  goManagePayments(){
    this.state.go('accountInformation', {
      activeTab: 3
    });
  }
  
}

 PaymentNoticeController.$inject = ['$state', 'AuthService'];



// WEBPACK FOOTER //
// ./src/app/pages/payment-notice/payment-notice.controller.js